module.exports = __webpack_public_path__ + "media/images/hitfun/welcome.socials.vkontakte-1c837a1094e0127ca61f1d423e7ded54.svg";